import React from "react";
import { Outlet } from "react-router-dom";
import { AppShell } from "./AppShell";
import { useScreenViewTracking } from "../hooks/useActivityTracking";

export const AppLayout = (): React.ReactElement => {
  // Entrada em tela do log de atividade. Fica AQUI, e não dentro do AppShell, porque o AppShell
  // é componente do design system (tem stories próprias) e não deve carregar telemetria da
  // aplicação. Este layout envolve toda rota autenticada, então um ponto cobre todas as telas.
  useScreenViewTracking();

  return (
    <AppShell environment="DEV">
      <Outlet />
    </AppShell>
  );
};
